import React from 'react';

import {
  ITextInputProps,
  TextInput,
} from '@rbilabs/components-library/build/components/text-input';
import { FieldProps } from 'formik';

export const FormikTextInput = React.forwardRef<
  HTMLInputElement,
  FieldProps<string, { [key: string]: string }> & ITextInputProps
>(({ field, form, ...props }, forwardedRef) => {
  const { errors, touched } = form;

  const fieldTouched = touched?.[field.name];
  const errorMessage = errors?.[field.name];

  return (
    <TextInput
      {...field}
      errorMessage={fieldTouched && errorMessage ? errorMessage : undefined}
      {...props}
      ref={forwardedRef}
    />
  );
});
